export const BACK_END_SKILLS = [
  { nom: "API REST", image: "/assets/img/icon/stack/restapi.webp" },
  { nom: "NodeJS", image: "/assets/img/icon/stack/node.webp" },
  { nom: "PHP",    image: "/assets/img/icon/stack/php.webp" },
  { nom: "Python", image: "/assets/img/icon/stack/python.svg" },
  { nom: "NestJS", image: "/assets/img/icon/stack/nestjs.svg" },
];
